import React from 'react'
import { Form, Row, Col, DropdownButton, Dropdown } from 'react-bootstrap'

// definitions
import { AccountXeroOrgWithData } from '../../../../screens/subsync/subsync'
import { XeroAPIContact } from '../../../../../../back-end/utilities/apiDefinitions'
import { DetailedStripeOrgAccountXeroOrg } from '../settings'

interface ShippingSettingsProps {
	orgMapping: DetailedStripeOrgAccountXeroOrg | undefined
	mappedXeroOrg: AccountXeroOrgWithData | undefined
	stripeOrgID: string
	handleSettingsUpdate: (stripeOrgID: string, values: { [name: string]: string | boolean | XeroAPIContact | undefined }) => void
}

const ShippingSettings = (props: ShippingSettingsProps) => {
	const [searchFilter, setSearchFilter] = React.useState<string>('')

	return (
		<>
			<Form.Group as={Row} style={{ height: '2.5rem' }}>
				<Form.Label column sm={2}>
					Xero Account
				</Form.Label>
				<Col sm={4}>
					<DropdownButton
						id={`${props.stripeOrgID}-shipping-settings-account-select`}
						title={
							props.mappedXeroOrg!.accounts.find(
								(a) => a.xeroAccountID === props.orgMapping?.stripeOrgAccountXeroOrgSettings?.shippingXeroAccountID
							)?.name || 'Select Xero Account'
						}
						onSelect={(eventKey) => {
							props.handleSettingsUpdate(props.stripeOrgID, { shippingXeroAccountID: eventKey! })
							setSearchFilter('')
						}}
					>
						<Form.Control
							type="text"
							placeholder="Search or enter value"
							value={searchFilter}
							onClick={(e: React.MouseEvent<HTMLInputElement>) => e.stopPropagation()} // Prevent dropdown from closing on input click
							onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchFilter(e.target.value)} // Handle input changes
						/>
						<Dropdown.Header>Revenue</Dropdown.Header>
						{props
							.mappedXeroOrg!.accounts.filter(
								(account) => account.type === 'REVENUE' && account.name!.toLowerCase().includes(searchFilter.toLowerCase())
							)
							.sort((a, b) => a.name!.localeCompare(b.name!, undefined, { numeric: true }))
							.map((xa) => (
								<Dropdown.Item key={xa.xeroAccountID} eventKey={xa.xeroAccountID}>
									{xa.name}
								</Dropdown.Item>
							))}
						<Dropdown.Header>Other Income</Dropdown.Header>
						{props
							.mappedXeroOrg!.accounts.filter(
								(account) => account.type === 'OTHERINCOME' && account.name!.toLowerCase().includes(searchFilter.toLowerCase())
							)
							.sort((a, b) => a.name!.localeCompare(b.name!, undefined, { numeric: true }))
							.map((xa) => (
								<Dropdown.Item key={xa.xeroAccountID} eventKey={xa.xeroAccountID}>
									{xa.name}
								</Dropdown.Item>
							))}
						<Dropdown.Header>Sales</Dropdown.Header>
						{props
							.mappedXeroOrg!.accounts.filter(
								(account) => account.type === 'SALES' && account.name!.toLowerCase().includes(searchFilter.toLowerCase())
							)
							.sort((a, b) => a.name!.localeCompare(b.name!, undefined, { numeric: true }))
							.map((xa) => (
								<Dropdown.Item key={xa.xeroAccountID} eventKey={xa.xeroAccountID}>
									{xa.name}
								</Dropdown.Item>
							))}
						<Dropdown.Header>Current Liability</Dropdown.Header>
						{props
							.mappedXeroOrg!.accounts.filter(
								(account) => account.type === 'CURRLIAB' && account.name!.toLowerCase().includes(searchFilter.toLowerCase())
							)
							.sort((a, b) => a.name!.localeCompare(b.name!, undefined, { numeric: true }))
							.map((xa) => (
								<Dropdown.Item key={xa.xeroAccountID} eventKey={xa.xeroAccountID}>
									{xa.name}
								</Dropdown.Item>
							))}
					</DropdownButton>
				</Col>
			</Form.Group>
		</>
	)
}

export { ShippingSettings }
